export default {
      id: "vague-usage",
      viewBox: "0 0 2500 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#vague-usage",
      toString: function () {
        return this.url;
      }
    }